export default class CustomSelect {
    /**
     * Costructor
     * @param container
     */
    constructor(container, callback) {
        if ( container instanceof HTMLElement ) {
            this.container = container;
        } else {
            this.container = document.querySelector(container);
        }

        this.callback = callback;
    }

    init () {
        const inputField = this.container.querySelector('.select-input');
        const dropdown = this.container.querySelector('.select-list');
        const placeholder = this.container.querySelector('.select-placeholder');
        const caret = this.container.querySelector('.caret');
        const dropdownArray = [... this.container.querySelectorAll('li')];
        console.log(this.container);

        placeholder.addEventListener('click', (e) => {
            e.stopPropagation();
            this.openDropdown(dropdown);
        });

        caret.addEventListener('click', (e) => {
            e.stopPropagation();
            this.openDropdown(dropdown);
        });

        dropdown.addEventListener ('transitionend', () => {
            //  console.log('animation end')
            dropdown.classList.toggle("scrollable");
        });

        dropdownArray.forEach( (item) => {
            // item.classList.remove('selected');

            item.addEventListener('click', (evt) => {
                if ( inputField.value !== item.dataset.slug) {
                    inputField.value = item.dataset.slug;
                    placeholder.innerHTML = item.innerHTML;
                    inputField.dispatchEvent(new Event('change'));

                    this.container.querySelector('.selected').classList.remove('selected');
                    evt.currentTarget.classList.add('selected');

                    this.callback (inputField.value);
                    dropdown.classList.remove('open');
                }
            });
        })

        document.addEventListener('click', (evt) => {
            console.log('document-click');
            const isDropdown = dropdown.contains(evt.target);
            const isInput = inputField.contains(evt.target);
            if (!isDropdown && !isInput) {
                dropdown.classList.remove('open');
            }
        });
    }

    openDropdown ( dp ) {
        let elements = document.querySelectorAll('.select-list');
        console.log (elements);

        elements.forEach( (item) => {
            if (item !== dp) {
                item.classList.remove('open');
            }
        })

        dp.classList.toggle('open');
    }
}
